import { ProductAvailabilityForm } from '@partials/forms/product-detail/product-availability'

export type IProductAvailabilityTab = Parameters<typeof ProductAvailabilityForm>[0]

export const ProductAvailabilityTab = ({ onError }: IProductAvailabilityTab) => {
  return <ProductAvailabilityForm onError={onError} />
}
